@if (options$ | async; as options) {
    <p-select
        class="small-select"
        [formControl]="valueControl"
        [options]="options"
        [placeholder]="'GENERIC.SELECT' | translate"
        optionLabel="label"
        optionValue="value"
        (onChange)="onValueChange($event)"
    />
}
